<template>
	<div class="d-flex">
		<b-card no-body class="border-gray flex-grow-1">
			<b-card-body class="p-0 d-flex flex-column">
				<!-- breadcums and button actions -->
				<div>
					<div class="d-flex justify-content-between p-3 border-gray border-bottom">
						<div class="text-dark m-0 align-self-center">
							Empresas 
							<a v-for="(item, index) in allSelected" 
								:key="`item_badge_${item.id}`"
								href="#" 
								:class="{'text-muted': index === allSelectedLength - 1}"
								@click.prevent="back(index)"
							> 
								/ {{ item.name }}
							</a>
						</div>
						<div class="d-flex justify-content-end" v-if="itemSelected">
							<b-button variant="outline-gray-700" class="ml-2" v-if="state === 'showing'" @click="startEdit">
								<b-icon icon="pencil"></b-icon> Editar
							</b-button>
						</div>
					</div>
				</div>

				<!-- Content -->
				<div class="d-flex flex-grow-1 overflow-hidden">
					<!-- Side content -->
					<div class="w-64 bg-gray-100 pb-3 d-flex flex-column">
						<b-button @click="startCreate" variant="ow-primary-500" block class="rounded-0">
							<b-icon icon="plus"></b-icon> Agregar
						</b-button>
						<transition
							name="custom"
							enter-active-class="animate__animated animate__fadeIn animate__faster"
        			leave-active-class="animate__animated animate__fadeOut animate__faster"
							mode="out-in"
						>
							<div v-if="isLoading" class="text-center py-3" key="loader">
								<b-icon icon="arrow-clockwise" animation="spin" class="text-gray-600" font-scale="2"></b-icon>
							</div>
							<b-list-group class="flex-grow-1" v-else key="list-group">
								<transition-group 
									name="custom-list"
									enter-active-class="animate__animated animate__fadeInUp animate__fast"
									leave-active-class="animate__animated animate__fadeOutUp animate_fast"
									tag="div"
									class="position-relative"
								>
									<b-list-group-item v-for="item in rootItems" 
										:key="`enterprise_${item.id}`"
										:active="isActive(item)"
										@click="selectItem(item)"
										href="#"
										class="border-0 text-gray-600 bg-gray-100 font-weight-bold position-relative hoverable-source rounded-0"

									>
										<b-icon icon="list" class="mr-2"></b-icon> {{ item.name }}
										<div class="position-absolute top-right hoverable h-100">
											
										</div>
									</b-list-group-item>
								</transition-group>
							</b-list-group>
						</transition>
					</div>

					<!-- Main content -->
					<transition
						enter-active-class="animate__animated animate__fadeIn animate__faster"
						leave-active-class="animate__animated animate__fadeOut animate__faster"
						mode="out-in"
					>
						<item-editor-panel v-if="state === 'creating' || state === 'editing'"></item-editor-panel>
						<item-panel v-else-if="itemSelected" :key="itemSelected.id"></item-panel>
						<div v-else class="flex-grow-1 d-flex justify-content-center align-items-center">
							<b-icon icon="box" font-scale="5" class="text-gray-600" ></b-icon>
						</div>
					</transition>
				</div>
			</b-card-body>
		</b-card>
	</div>
</template>

<script>
import { 
	mapOrganizationChartState, 
	mapOrganizationChartGetters, 
	mapOrganizationChartMutations, 
	mapOrganizationChartActions 
} from "../store/modules/organization-chart";

import ItemEditorPanel from '../components/organization-chart/ItemEditorPanel.vue';
import ItemPanel from '../components/organization-chart/ItemPanel.vue';

export default {
	data() {
		return {
		
		}
	},
	components: {
		ItemEditorPanel,
		ItemPanel,
	},
	computed: {
		...mapOrganizationChartState({
			isLoading: state => state.isLoading,
			state: state => state.state,
			itemEditing: state => state.itemEditing,
		}),
		...mapOrganizationChartGetters([
			'rootItems',
			'itemSelected',
			'allSelected',
			'allSelectedLength',
			'payrollCategories',
			'children',
			'jobTitles',
		]),
	},
	mounted() {
		this.loadTree();
	},
	methods: {
		...mapOrganizationChartActions([
			'loadTree',
			'selectItem',
			'startCreate',
			'startEdit',
			'back',
		]),
		...mapOrganizationChartMutations([
			'updateItem',
		]),
		isActive(enterprise) {
			if (this.itemSelected === null) return false;
			
			return this.itemSelected.id === enterprise.id;
		}
	},
}
</script>